import { cn } from '@cobliteam/colib-ui/cn';
import RadioGroup, { RadioGroupItem } from '@cobliteam/colib-ui/RadioGroup';
import { Typography } from '@cobliteam/ui/components';
import type { MultipleSurveyQuestion } from 'posthog-js';

interface Props {
  question: MultipleSurveyQuestion;
  value?: string;
  onChange: (value: string) => void;
  hideTitle?: boolean;
}

const splitEmojiPrefix = (s: string): { emoji: string | null; label: string } => {
  const match = s.match(/^(\p{Extended_Pictographic}(?:‍\p{Extended_Pictographic})*️?)\s+(.*)$/u);
  if (match) return { emoji: match[1], label: match[2] };
  return { emoji: null, label: s };
};

const QuestionSingleChoice = ({ question, value, onChange, hideTitle = false }: Props) => {
  const choices = question.choices ?? [];

  return (
    <div className='flex flex-col gap-3'>
      {!hideTitle && (
        <Typography variant='text-md' className='font-medium'>
          {question.question}
        </Typography>
      )}
      <RadioGroup value={value} onValueChange={onChange} className='flex flex-col gap-2'>
        {choices.map((choice, idx) => {
          const id = `choice-${idx}`;
          const selected = value === choice;
          const { emoji, label } = splitEmojiPrefix(choice);
          return (
            <label
              key={choice}
              htmlFor={id}
              className={cn(
                'flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-3 transition-colors',
                selected ? 'border-primary bg-secondary' : 'border-border hover:bg-muted'
              )}
            >
              <RadioGroupItem value={choice} id={id} />
              {emoji ? <span className='text-lg leading-none'>{emoji}</span> : null}
              <Typography variant='text-sm'>{label}</Typography>
            </label>
          );
        })}
      </RadioGroup>
    </div>
  );
};

export default QuestionSingleChoice;
